import { Component, EventEmitter, Input, Output, OnInit, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ComponentService, CreatorFrontApi } from '../../../services/component.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
	selector: 'app-name-field',
	templateUrl: './name-field.component.html',
	styleUrls: ['./name-field.component.scss'],
	viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class NameFieldComponent implements OnInit, OnDestroy {
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() onModelChange = new EventEmitter<any>();
	@Input() componentData: any;
	@Input() model;
	@Input() iconClasses: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@ViewChild('componentName', { static: true }) componentName: ElementRef;
	public nameForm;
	editComponentName = false;
	duplicateName = false;
	nameLength = false;
	nameValidationSubscription;

	constructor(private cs: ComponentService, private cd: ChangeDetectorRef, public controlContainer: ControlContainer) {}

	ngOnInit() {
		this.nameForm = this.controlContainer.control;
		if (this.pageType == 'new' || this.pageType == 'duplicate') {
			this.setEditNameFocus();
			this.editComponentName = true;
			this.setEditNameSelect();
		}
	}

	ngOnDestroy() {
		if (this.nameValidationSubscription) {
			this.nameValidationSubscription.unsubscribe();
		}
	}

	setEditNameFocus() {
		setTimeout(() => {
			this.componentName.nativeElement.focus();
			this.cs.updateDisabledSave(true);
		}, 10);
	}

	setEditNameSelect() {
		setTimeout(() => this.componentName.nativeElement.select(), 10);
	}

	editNameCheck() {
		this.nameValidationSubscription = this.cs.validateName(this.model, this.componentID).subscribe(
			(response: CreatorFrontApi) => {
				if (response && response.status) {
					if (response.data) {
						this.cs.updateDisabledSave(false);
						this.duplicateName = false;
						this.nameLength = false;
						this.nameForm.controls['componentName'].setErrors(null);
						this.cd.detectChanges();
					} else {
						this.cs.updateDisabledSave(true);
						this.nameForm.controls['componentName'].setErrors({ invalid: true });
						this.duplicateName = true;
						this.nameLength = false;
						this.cd.detectChanges();
					}
				}
			},
			(err) => {
				if (err == 'name length error' || err == 'name does not exist') {
					this.cs.updateDisabledSave(true);
					this.nameLength = true;
					this.cd.detectChanges();
					this.nameForm.controls['componentName'].setErrors({ invalid: true });
				}
			}
		);
		this.onModelChange.emit({ name: this.model });
	}
}
